module.exports = __webpack_public_path__ + "static/Logo-4861c46d248936411f31ecf0269057cc.png";